import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { hasModuleAccess } from '../services/accessService.js';
import { authenticationService } from '../services/authenticationService.js';

export const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={props => {
        const { access, moduleName, ...other} = rest;
        const isAcc = hasModuleAccess(moduleName, access);

        const currentUser = authenticationService.getCurrentUser();
        if (!currentUser) {
            // not logged in so redirect to login page with the return url
            return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
        }

        if(!isAcc){
            return <Redirect to='/'/>
        }
        // authorised so return component
        return <Component {...{...props, ...other}}/>;
    }} />
)